<template>
  <v-main>
    <div class="d-flex w-full h-full pa-0">
      <OLoadingDialog :value="isLoading" />

      <div class="w-250 border-gray border-r-1 bg-gray grow-0 shrink-0">
        <SidebarHeaders :headers="headers" class="mt-1 pa-2" />

        <div class="text-center">
          <span class="tag red text-caption" v-if="row && row.deletedAt">
            Inativo desde {{ row.deletedAt | moment('DD/MM/YYYY') }}
          </span>
        </div>

        <DesktopSideBar :tabItems="tabItems" :currentTab.sync="currentTab" />
      </div>

      <!-- w-0 é um WTF, vide layout.sass -->
      <div class="w-0 grow-1">
        <TabContainer
          v-if="row != null"
          @reload="reload"
          :tabItems="tabItems"
          :currentTab="currentTab"
          :value="row"
        />
      </div>
    </div>
  </v-main>
</template>

<script>
// import moment from 'moment'
import SidebarHeaders from 'oderon-vue/cpts/tabbed-interface/SidebarHeaders.vue'
import DesktopSideBar from 'oderon-vue/cpts/tabbed-interface/DesktopSideBar.vue'
import TabContainer from 'oderon-vue/cpts/tabbed-interface/TabContainer.vue'
import EditStore from './EditStore'

export default {
  components: {
    SidebarHeaders,
    DesktopSideBar,
    TabContainer
  },

  props: {
    id: { required: true }
  },

  mounted() {
    EditStore.load(this.id)
  },

  watch: {
    id() {
      EditStore.load(this.id)
    }
  },

  computed: {
    currentTab: {
      get() {
        return EditStore.currentTab
      },
      set(x) {
        EditStore.currentTab = x
      }
    },
    isLoading() {
      return EditStore.isLoading
    },
    row() {
      return EditStore.row
    },
    tabItems() {
      return EditStore.tabItems
    },

    headers() {
      let { customer, org } = this.row || {}

      let result = [
        {
          icon: 'mdi-credit-card-outline',
          text: this.row && this.row.name,
          primary: true
        },
        {
          icon: 'mdi-account-tie',
          text: customer ? customer.label : '(sem cliente)',
          action: customer ? '#' + customer.id : ''
        },
        {
          icon: 'mdi-desktop-tower-monitor',
          text: org ? org.label : '(sem sistema)',
          action: org ? '#' + org.id : ''
        }
      ]

      // if (this.row && this.row.deletedAt != null) {
      //   result.splice(1, 0, {
      //     icon: '',
      //     text:
      //       'Inativo desde ' + moment(this.row.deletedAt).format('DD/MM/YYYY')
      //   })
      // }

      return result
    }
  },
  methods: {
    reload() {
      EditStore.load(this.id)
    }
  }
}
</script>

<style></style>
